import React from "react";
import styled from "styled-components";

import { getAdminActionsForTab } from "./registry";

export default function AdminActionGrid({
  activeTab,
  density = "large",
  navigate,
  onOpenPanel,
}) {
  const actions = getAdminActionsForTab(activeTab);
  const isMini = density === "mini";

  if (!actions.length) {
    return null;
  }

  const handleActionClick = (actionConfig) => {
    const { action } = actionConfig;

    if (action.type === "route") {
      navigate(action.route);
      return;
    }

    if (action.type === "panel") {
      onOpenPanel(action.panelMode, actionConfig.tab);
    }
  };

  return (
    <CardGrid $mini={isMini} data-density={density}>
      {actions.map((actionConfig) => (
        <AdminActionCard
          key={`${actionConfig.tab}-${actionConfig.title}`}
          $mini={isMini}
          title={isMini ? actionConfig.title : undefined}
          aria-label={actionConfig.title}
          onClick={() => handleActionClick(actionConfig)}
        >
          <ActionIcon aria-hidden="true">
            {actionConfig.icon}
          </ActionIcon>

          <ActionTitle $mini={isMini}>
            {actionConfig.title}
          </ActionTitle>

          <ActionDescription $mini={isMini}>
            {actionConfig.description}
          </ActionDescription>
        </AdminActionCard>
      ))}
    </CardGrid>
  );
}

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ $mini }) =>
    $mini ? "1fr" : "repeat(auto-fit, minmax(320px, 1fr))"};
  gap: ${({ $mini }) => ($mini ? "0.55rem" : "1.1rem")};
  width: 100%;
`;

const AdminActionCard = styled.button`
  width: 100%;
  min-width: 0;
  min-height: ${({ $mini }) => ($mini ? "64px" : "250px")};
  padding: ${({ $mini }) => ($mini ? "0.5rem" : "1.4rem")};
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: ${({ $mini }) => ($mini ? "16px" : "18px")};
  background: #202a43;
  color: #f7f7f7;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  align-items: ${({ $mini }) => ($mini ? "center" : "stretch")};
  justify-content: ${({ $mini }) =>
    $mini ? "center" : "space-between"};

  text-align: ${({ $mini }) => ($mini ? "center" : "left")};
  font: inherit;
  transition:
    background 0.18s ease,
    border-color 0.18s ease,
    transform 0.18s ease;

  &:hover,
  &:focus-visible {
    background: #26324f;
    border-color: rgba(255, 255, 255, 0.28);
    transform: translateY(-2px);
  }

  &:focus-visible {
    outline: 2px solid #fff9ea;
    outline-offset: 2px;
  }
`;

const ActionIcon = styled.span`
  display: block;
  font-size: 1.65rem;
  line-height: 1;
`;

const ActionTitle = styled.h3`
  display: ${({ $mini }) => ($mini ? "none" : "block")};
  margin: 0.8rem 0 0.5rem;
  font-size: 1.17rem;
`;

const ActionDescription = styled.p`
  display: ${({ $mini }) => ($mini ? "none" : "block")};
  margin: 0;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.45;
`;
